module.exports = __webpack_public_path__ + "static/media/Body_Mass_Index.4b63d09d.jpg";